function Selling(props) {
  return <h1>Bán chạy</h1>;
}

export default Selling;
